// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".markdown-message .markdown-table-wrapper{overflow-x:auto;background-color:#e5e3e3;border:1px solid #7b8b8a;border-radius:6px;margin:20px 0}.markdown-message .markdown-table-wrapper table{width:100%;border-collapse:collapse}.markdown-message .markdown-table-wrapper table th{background-color:#a09f9f;color:#fff;font-weight:500}.markdown-message .markdown-table-wrapper table td,.markdown-message .markdown-table-wrapper table th{padding:.5rem 1rem;border:1px solid #7b8b8a}", ""]);
// Exports
module.exports = exports;
